/* @flow */

export const blobToURL = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      reject(error);
    }
  });



// WEBPACK FOOTER //
// ./src/utils/blob.js